import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

function getCurrentSeason() {
  const month = new Date().getMonth() + 1;
  if (month === 12 || month === 1) return 'winter';
  if (month === 10) return 'halloween';
  if (month >= 6 && month <= 8) return 'summer';
  return null;
}

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('grs-theme') || 'dark';
  });
  const [season, setSeason] = useState(() => getCurrentSeason());

  useEffect(() => {
    localStorage.setItem('grs-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    if (theme === 'light') {
      document.documentElement.classList.add('light-theme');
      document.documentElement.classList.remove('dark-theme');
    } else {
      document.documentElement.classList.add('dark-theme');
      document.documentElement.classList.remove('light-theme');
    }
  }, [theme]);

  useEffect(() => {
    // Apply seasonal class
    document.documentElement.classList.remove('season-winter', 'season-halloween', 'season-summer');
    if (season) {
      document.documentElement.classList.add(`season-${season}`);
    }
  }, [season]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, season, setSeason }}>
      {children}
    </ThemeContext.Provider>
  );
};
